var userData = null;
function setUserCookie(name, value, days) {
  let expires = "";
  if (days) {
    let date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function getUserCookie(name) {
  let nameEQ = name + "=";
  let ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1, c.length); // Trim leading spaces
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

function valueExists(array, key, value) {
  return array.some(function(obj) {
    return obj[key] === value;
  });
}

function updateValue(array, key, valueToFind, newValue, secondValue, videoEnabled) {
  array.forEach(function(obj) {
    if (obj[key] === valueToFind) {
      obj['videoCompleted'] = newValue;
      obj['answered'] = secondValue;
      obj['videoEnabled'] = videoEnabled;
    }
  });
  return array;
}

function getValueByKey(array, key, value, search) {
  for (var i = 0; i < array.length; i++) {
    if (array[i][key] === value) {
      return array[i][search];
    }
  }
  return 0;
}

console.log(getUserCookie('current_education'));

function setOrUpdateCookie(video, videoCompleted=0, videoEnabled=1, answered=0) {
  let cookieName = 'user_data';
  // Check if the cookie exists
  let existingCookie = getUserCookie(cookieName);
  if (all_chapters != null) {
    var order = 0;
		var last = 0;
    $.each(all_chapters, function(index, chapter) {
      if (chapter.chapter_id == chapter_id) {
				console.log(chapter.videos.length);
        $.each(chapter.videos, function(i, item) {
          if (video == item) {
            order = i;
						if (order == chapter.videos.length - 1) {
							last = 1;
						}
          }
        });
      }
    });
    console.log(all_chapters);
    console.log(video);
    console.log(order);
		console.log(last)


    let newData = {
      chapters: chapter_id.toString(),
      videos: video
    };
    let new_video = {
      id: video,
      order: order,
      videoTimeViewedInSeconds: 0,
      videoCompleted: videoCompleted,
      videoEnabled: videoEnabled,
      answered: answered,
			last: last
    };

    if (existingCookie) {
      // Parse the existing cookie data
      let user_data = JSON.parse(existingCookie);
      console.log(user_data.chapters);

      // Update specific fields
      user_data.chapters = user_data.chapters.includes(newData.chapters) ? user_data.chapters : user_data.chapters + ',' + newData.chapters;
      user_data.videos = user_data.videos.includes(newData.videos) ? user_data.videos : user_data.videos + ',' + newData.videos;
      if (!('progress' in user_data)) {
        user_data.progress = {};
      }
      if (!(chapter_id in user_data.progress)) {
        user_data.progress[chapter_id] = [];
      }
      if (chapter_id in user_data.progress && valueExists(user_data.progress[chapter_id], 'id', video)) {
        user_data.progress[chapter_id] = updateValue(user_data.progress[chapter_id], 'id', video, videoCompleted, answered, videoEnabled);
      } else {
        user_data.progress[chapter_id].push(new_video);
      }

      console.log("Cookie exists. Updating data...");
      console.log(user_data);

      // Set the updated cookie with a 1-year expiration
      setUserCookie(cookieName, JSON.stringify(user_data), 365);
    } else {
      // If the cookie doesn't exist, create a new one
      console.log("Cookie does not exist. Creating new cookie...");
      newData.progress = {};
      newData.progress[chapter_id] = [];
      newData.progress[chapter_id].push(new_video);
      console.log(newData);
      // Set the new cookie with a 1-year expiration
      setUserCookie(cookieName, JSON.stringify(newData), 365);
    }
    console.log('Cookie set or updated!');
  } else {
    console.log("all_chapters is not set");
  }
}
